/**
 * Dashboard Service
 * API calls for dashboard statistics and overview data
 */

import apiClient from '../lib/axios';

export interface DashboardStats {
  totalMembers: number;
  totalMembersChange: number;
  totalTeams: number;
  totalTeamsChange: number;
  totalUsers: number;
  appLogins: {
    thisWeek: number;
    lastWeek: number;
    changePercent: number;
  };
  completedQuizzes: {
    thisWeek: number;
    lastWeek: number;
    changePercent: number;
  };
  newMembers: number;
}

export interface RecentlyModifiedMember {
  id: number;
  first_name: string;
  last_name: string;
  has_profile_picture: boolean;
  updated_at: string;
}

export interface UpcomingBirthdayMember {
  id: number;
  first_name: string;
  last_name: string;
  has_profile_picture: boolean;
  date_of_birth: string;
  days_until: number;
}

export interface PhotoMissingMember {
  id: number;
  first_name: string;
  last_name: string;
  has_profile_picture: boolean;
  date_joined: string;
  team_name: string | null;
}

export interface DashboardOverview {
  recentlyModified: RecentlyModifiedMember[];
  upcomingBirthdays: UpcomingBirthdayMember[];
  photosMissing: PhotoMissingMember[];
}

export const dashboardService = {
  /**
   * Get dashboard statistics
   */
  getStats: async (): Promise<DashboardStats> => {
    const { data } = await apiClient.get<DashboardStats>(
      '/dashboard/stats'
    );
    return data;
  },

  /**
   * Get dashboard overview data
   */
  getOverview: async (): Promise<DashboardOverview> => {
    const { data } = await apiClient.get<DashboardOverview>(
      '/dashboard/overview'
    );
    return data;
  },
};
